import Vue from 'vue'
import Router from 'vue-router'
// 首页
import Index from '../pages/Home.vue'
// 最新更新
import LatestUpdates from '../pages/LatestUpdates/LatestUpdates.vue'
// 隧说网事
import TunnelOnline from '../pages/LatestUpdates/tunnelOnline.vue'
// 详情
import BookDetail from '../pages/BookDetails/BookDetail.vue'
// 目录
import BookCatalog from '../pages/BookDetails/BookCatalog.vue'
// 评论
import BookComment from '../pages/BookDetails/BookComment.vue'
// 试读
import BookTryRead from '../pages/BookDetails/BookTryRead.vue'
// 阅读
import BookRead from '../pages/BookDetails/BookRead.vue'
// 付款界面
import BookPayment from '../pages/BookDetails/BookPayment.vue'
// 支付成功
import PaySuccess from '../pages/Payment/PaySuccess.vue'
// 支付失败
import PayError from '../pages/Payment/PayError.vue'
// 我的书单
import MyBookList from '../pages/MemberCenter/MyBookList.vue'
// 订单详情
import OrderInfo from '../pages/MemberCenter/OrderInfo.vue'
// 购物车
import MyCart from '../pages/MyCart/MyCart.vue'
// 购物车详情
import ConfirmOrder from '../pages/MyCart/ConfirmOrder.vue'
// 我的订单
import MyOrderList from '../pages/MemberCenter/MyOrderList.vue'
// 深邃合集
import DeepCompDetail from '../pages/DeepCompilations/DeepCompDetail.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect:'Index'
		},
		{
			path: '/index',
			name: 'Index',
			component: Index
		},
		{
			path: '/latestUpdates',
			name: 'LatestUpdates',
			component: LatestUpdates
		},
		{
			path: '/tunnelOnline',
			name: 'TunnelOnline',
			component: TunnelOnline
		},
		{
			path: '/bookDetail',
			name: 'BookDetail',
			component: BookDetail,
			children:[
				{
					path: 'bookCatalog',
					name: 'BookCatalog',
					component: BookCatalog
				}
			],
			redirect: '/bookDetail/bookCatalog'
		},
		{
			path: '/bookComment',
			name: 'BookComment',
			component: BookComment
		},
		{
			path: '/bookTryRead',
			name: 'BookTryRead',
			component: BookTryRead
		},
		{
			path: '/bookRead',
			name: 'BookRead',
			component: BookRead
		},
		{
			path: '/bookPayment',
			name: 'BookPayment',
			component: BookPayment
		},
		{
			path: '/paySuccess',
			name: 'PaySuccess',
			component: PaySuccess
		},
		{
			path: '/payError',
			name: 'PayError',
			component: PayError
		},
		{
			path: '/myBookList',
			name: 'MyBookList',
			component: MyBookList
		},
		{
			path: '/orderInfo',
			name: 'OrderInfo',
			component: OrderInfo
		},
		{
			path: '/myCart',
			name: 'MyCart',
			component: MyCart
		},
		{
			path: '/confirmOrder',
			name: 'ConfirmOrder',
			component: ConfirmOrder
		},
		{
			path: '/myOrderList',
			name: 'MyOrderList',
			component: MyOrderList
		},
    {
      path: '/deepCompDetail',
      name: 'DeepCompDetail',
      component: DeepCompDetail
    }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js